module.exports = __webpack_public_path__ + "img/tempLogo.e43cd2da.jpg";